import { Modal, Table } from 'antd';
import { ColumnsType, TableProps } from 'antd/lib/table';
import filesize from 'filesize';
import React, { ReactElement, ReactNode } from 'react';
import ILoanEmailAttachment from '~Api/LoanEmail/ILoanEmailAttachment';
import './emails.less';

export default function AttachmentsModal(props: {
    attachments: ILoanEmailAttachment[];
    isOpen: boolean;
    onCancel: () => void;
}): ReactElement {
    const { attachments, isOpen, onCancel } = props;

    const columns: ColumnsType<ILoanEmailAttachment> = [
        {
            key: 'filename',
            render: (attachment: ILoanEmailAttachment): ReactNode => (
                <a
                    href={`${process.env.API_HOST}/loan-email-attachments/${attachment.uuid}/download`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {attachment.filename}
                </a>
            ),
            title: 'Filename',
        },
        {
            key: 'size',
            render: (attachment: ILoanEmailAttachment): ReactNode => filesize(attachment.bytes, {
                base: 2,
                round: 1,
                standard: 'jedec',
            }),
            title: 'Size',
            width: 110,
        },
    ];
    const scroll: TableProps<ILoanEmailAttachment>['scroll'] = { y: 400 };

    return (
        <Modal
            className='loan-emails-attachments-modal'
            footer={false}
            onCancel={onCancel}
            open={isOpen}
            title='Attachments'
            width={760}
        >
            <Table
                columns={columns}
                dataSource={attachments}
                pagination={false}
                rowKey='uuid'
                scroll={scroll}
                size='small'
            />
        </Modal>
    );
}
